module.exports = __webpack_public_path__ + "img/writing_sudoku-hover.c8769b1a.svg";